<mat-icon style="float: right; cursor: pointer" (click)="close()">clear</mat-icon>

<soillib-surveys-import-csv
  [level]="'jobsite'"
  [datumDisplayName]="data.currentJobsite?.datumDisplayName ?? 'NGF'"
  [isSBT]="isSBT"
  (finishAgsImportEvent)="finishAgsImport($event)"
></soillib-surveys-import-csv>
